export const LOAD_INFO_VALIDATE_FILE = 'LOAD_INFO_VALIDATE_FILE';
export const SET_LOADING = 'SET_LOADING';
